import { styled, TableCell, tableCellClasses, TableRow } from '@mui/material';

import MethodStep from './ExportTable/MethodStep';
import { FoodComponent, FoodComponentMethodStep, Ingredient } from '../../../libs/types';
import { roundToTwoDecimals } from '../../../libs/utils/helperFunctions';
import { calculateFractionWeight } from '../../../views/ComponentsCheck/helpers';

export interface IngredientRowProps {
  ingredient: Ingredient;
  index: number;
  bufferedCookedWeight: number;
  component: FoodComponent;
  componentMethod: FoodComponentMethodStep[];
  totalIngredients: number;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.neutral100,
    color: theme.palette.common.black,
    border: 'none',
    fontSize: 16,
    fontWeight: 600
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
    paddingTop: '2px',
    paddingBottom: '2px'
  }
}));

const IngredientRow = ({
  ingredient,
  index,
  bufferedCookedWeight,
  component,
  componentMethod,
  totalIngredients
}: IngredientRowProps) => {
  if (!ingredient) return null;

  const ingredientName = ingredient.internalName || ingredient.name?.en || ingredient.id;

  const fractionWeight = calculateFractionWeight(component, ingredient.quantity ?? 0, bufferedCookedWeight, ingredient.weight);

  const wastageMultiplier = ingredient.wastage ?? 1;
  const quantityBeforePrep = fractionWeight * wastageMultiplier;
  const quantityAfterPrep = fractionWeight;

  return (
    <TableRow key={ingredient.id ?? index} sx={{ fontWeight: 'bold' }}>
      <StyledTableCell>{ingredientName}</StyledTableCell>
      <StyledTableCell sx={{ paddingLeft: 0 }}>
        {quantityBeforePrep < 1 ? roundToTwoDecimals(quantityBeforePrep) : Math.ceil(Math.round(quantityBeforePrep))}
      </StyledTableCell>
      <StyledTableCell sx={{ paddingLeft: 0 }}>
        {quantityAfterPrep < 1 ? roundToTwoDecimals(quantityAfterPrep) : Math.ceil(Math.round(quantityAfterPrep))}
      </StyledTableCell>
      <StyledTableCell sx={{ paddingLeft: 0 }}>g</StyledTableCell>
      {index === 0 && componentMethod.length > 0 && (
        <StyledTableCell sx={{ width: '45%', verticalAlign: 'top' }} rowSpan={totalIngredients}>
          <MethodStep methods={componentMethod.filter((m): m is FoodComponentMethodStep => !!m)} />
        </StyledTableCell>
      )}
    </TableRow>
  );
};

export default IngredientRow;
export { StyledTableCell };
